import React from 'react';
import { FormImageFieldModal } from '../../../../media-management/components/form-image/FormImageFieldModal';
import { ElementWrapper } from '../../../components/ElementWrapper';
import { IElement } from '../../../models/Element';
import { PluginRightImageInfoNoButtons } from './PluginRightImageInfoNoButtons';
import { PluginRightImageInfoNoButtonsContent } from './PluginRightImageInfoNoButtonsContent';
import { PluginRightImageInfoNoButtonsFigure } from './PluginRightImageInfoNoButtonsFigure';

type Props = {
  index: number;
  data: PluginRightImageInfoNoButtons;
  updateData: (element: IElement, index: number) => void;
};

export const PluginRightImageInfoNoButtonsFC: React.FC<Props> = ({
  index,
  data,
  updateData,
}) => {
  const update = (fieldsToUpdate: Partial<PluginRightImageInfoNoButtons>) => {
    const updatedData = { ...data, ...fieldsToUpdate };
    updateData(updatedData, index);
  };
  return (
    <>
      <FormImageFieldModal
        modalId={`${data.name}-${data.id}`}
        name={`image`}
        altText={`image_alt`}
        update={update}
      />

      <ElementWrapper elementIndex={index}>
        <div className="plugin-right-image-info">
          <div className="showcase">
            <PluginRightImageInfoNoButtonsContent data={data} update={update} />
            <PluginRightImageInfoNoButtonsFigure data={data} update={update} />
          </div>
        </div>
      </ElementWrapper>
    </>
  );
};
